module.exports = __webpack_public_path__ + "media/theme/icon_deliver-d9514240.png";